import React from 'react';
import { withStyles, WithStyles } from '@mui/styles';
import HTTP from 'services/http';
import { buildQaId } from 'utils/build-qa-id';
import { useDispatch } from 'react-redux';
import { Grid, Button } from '@mui/material';
import { notifyError, notifySuccess } from 'actions/action-notifications';
import { FillDeliveryConfirmationStatus } from 'interfaces/enums/TaskStatuses/FillDeliveryConfirmationStatus';
import { IPickUpButton } from './types';
import { ShippingStyles } from './shipping.styles';
import { FDC, EDIT_FILL_DELIVERY_CONFIRMATION } from '../../constants/index';

const qaIdBuilder = buildQaId('shipping');

interface IShippingProps extends IPickUpButton, WithStyles<typeof ShippingStyles> {}

const PickupButton = (props: IShippingProps): JSX.Element => {
  const { classes, currentFdcInformation, disabled, updateShippingPage = () => {} } = props;
  const [updating, setUpdating] = React.useState(false);
  const dispatch = useDispatch();

  const getPickup = async () => {
    setUpdating(true);
    try {
      const updatedTask = {
        id: currentFdcInformation?.id,
        taskType: FDC,
        therapy_id: currentFdcInformation?.therapyId,
        status_id: FillDeliveryConfirmationStatus.WillPickUp,
      };
      const patchUrl = `/tasks/fdc/${updatedTask.id}`;
      const response = await HTTP.patch(patchUrl, updatedTask, {});
      const reduxPayload = {
        type: EDIT_FILL_DELIVERY_CONFIRMATION,
        payload: response,
      };
      dispatch(reduxPayload);
      dispatch(notifySuccess('FDC was successfully updated'));
      updateShippingPage();
    } catch (error) {
      console.log('pickup-button.error: ', error);
      const notifyMessage = 'Unable to update FDC.';
      dispatch(notifyError(notifyMessage));
    } finally {
      setUpdating(false);
    }
  };

  return (
    <Grid item className={classes.printLabelButton}>
      <Button
        color="primary"
        variant="contained"
        onClick={async () => {
          return getPickup();
        }}
        data-qa-id={qaIdBuilder('button.print-label')}
        disabled={disabled || updating}
      >
        {updating ? '....Processing' : 'Ready for Pickup'}
      </Button>
    </Grid>
  );
};

export default withStyles(ShippingStyles)(PickupButton);
